import { API_BASE_URL } from '../services/api'

// Resolve backend-served media (e.g. /uploads/avatars/...) to an absolute
// URL that works in every environment.
//
// Why this exists (2026-07-01 avatar regression): components used
//   const BASE_URL = import.meta.env.VITE_BASE_URL || 'http://localhost:3001'
// but production builds don't define VITE_BASE_URL, so every uploaded image
// resolved to http://localhost:3001/uploads/... — broken (and mixed-content
// blocked) on app.villaexperience.com. VITE_API_BASE_URL *is* defined in
// prod builds, so derive the static-file origin from it instead: strip the
// trailing /api to get the backend origin that also serves /uploads.
// Falls back to the current origin (works when nginx proxies /uploads on
// the same host, which is the prod setup).
export function resolveMediaUrl(url) {
  if (!url) return null
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith('/uploads')) {
    const apiOrigin = API_BASE_URL?.replace(/\/api\/?$/, '') || window.location.origin
    return `${apiOrigin}${url}`
  }
  return url
}
